import type { Permissao } from '@baiocchi/shared'
import type { ComponentType, SVGProps } from 'react'

import {
  IconeAgenda,
  IconeConfiguracoes,
  IconeGrafico,
  IconeInicio,
  IconeLeads,
  IconeMegafone,
  IconePainel,
  IconeUsuario,
} from '../componentes/icones'

export interface ItemNavegacao {
  rotulo: string
  para: string
  icone: ComponentType<SVGProps<SVGSVGElement>>
  /** Permissões exigidas (E). Ausente = todo papel autenticado vê. */
  permissoes?: ReadonlyArray<Permissao>
  /** Submenu — o "Configurações" da sidebar do legado. */
  filhos?: ReadonlyArray<Omit<ItemNavegacao, 'icone' | 'filhos'>>
}

/**
 * Navegação da sidebar.
 *
 * A ordem espelha a do legado (Home, Atendimentos, Leads, Agendamentos,
 * Usuários, Configurações) porque a operação já tem o caminho na memória muscular
 * — mudar a ordem é custo de treinamento sem ganho.
 *
 * Cada item declara as **mesmas permissões que o backend exige** na rota
 * correspondente. Item sem permissão não aparece; isso é conveniência de
 * interface, não autorização (RNF-20).
 */
export const NAVEGACAO: ReadonlyArray<ItemNavegacao> = [
  { rotulo: 'Início', para: '/', icone: IconeInicio, permissoes: ['DASHBOARD_LER'] },
  { rotulo: 'Atendimentos', para: '/atendimentos', icone: IconePainel, permissoes: ['PAINEL_LER'] },
  { rotulo: 'Leads', para: '/leads', icone: IconeLeads, permissoes: ['LEAD_LER'] },
  {
    rotulo: 'Agendamentos',
    para: '/agendamentos',
    icone: IconeAgenda,
    permissoes: ['AGENDAMENTO_LER'],
  },
  { rotulo: 'Usuários', para: '/usuarios', icone: IconeUsuario, permissoes: ['USUARIO_LER'] },
  {
    rotulo: 'Meta Ads',
    para: '/meta-ads',
    icone: IconeMegafone,
    permissoes: ['META_ADS_LER'],
    filhos: [
      { rotulo: 'Visão geral', para: '/meta-ads', permissoes: ['META_ADS_LER'] },
      { rotulo: 'Campanhas', para: '/meta-ads/campanhas', permissoes: ['META_ADS_LER'] },
      { rotulo: 'Métricas', para: '/meta-ads/metricas', permissoes: ['META_ADS_LER'] },
      { rotulo: 'Diagnóstico', para: '/meta-ads/diagnostico', permissoes: ['META_ADS_LER'] },
      {
        rotulo: 'Recomendações da IA',
        para: '/meta-ads/recomendacoes',
        permissoes: ['META_ADS_ANALISAR'],
      },
      { rotulo: 'Otimizador', para: '/meta-ads/otimizador', permissoes: ['META_ADS_ANALISAR'] },
      { rotulo: 'Histórico', para: '/meta-ads/otimizacoes', permissoes: ['META_ADS_LER'] },
      { rotulo: 'Contas', para: '/meta-ads/contas', permissoes: ['META_ADS_GERENCIAR'] },
    ],
  },
  {
    rotulo: 'Relatórios',
    para: '/relatorios',
    icone: IconeGrafico,
    permissoes: ['RELATORIO_VENDAS_LER'],
    filhos: [
      { rotulo: 'Funil de conversão', para: '/relatorios/funil', permissoes: ['RELATORIO_VENDAS_LER'] },
      { rotulo: 'Perdas por motivo', para: '/relatorios/perdas', permissoes: ['RELATORIO_VENDAS_LER'] },
      { rotulo: 'Vendas', para: '/relatorios/vendas', permissoes: ['RELATORIO_VENDAS_LER'] },
      {
        rotulo: 'Propostas',
        para: '/relatorios/propostas',
        permissoes: ['RELATORIO_PROPOSTAS_LER'],
      },
    ],
  },
  {
    rotulo: 'Configurações',
    para: '/configuracoes',
    icone: IconeConfiguracoes,
    permissoes: ['CATALOGO_LER'],
    filhos: [
      { rotulo: 'Unidades', para: '/configuracoes/unidades', permissoes: ['UNIDADE_GERENCIAR'] },
      { rotulo: 'Equipes', para: '/configuracoes/equipes', permissoes: ['EQUIPE_GERENCIAR'] },
      {
        rotulo: 'Pontos de conversão',
        para: '/configuracoes/pontos-conversao',
        permissoes: ['CATALOGO_GERENCIAR_ESTRUTURAL'],
      },
      {
        rotulo: 'Produtos associados',
        para: '/configuracoes/produtos-associados',
        permissoes: ['CATALOGO_GERENCIAR_ESTRUTURAL'],
      },
      {
        rotulo: 'Motivos de agendamento',
        para: '/configuracoes/motivos-agendamento',
        permissoes: ['CATALOGO_GERENCIAR_OPERACIONAL'],
      },
      {
        rotulo: 'Motivos de venda não realizada',
        para: '/configuracoes/motivos-venda-nao-realizada',
        permissoes: ['CATALOGO_GERENCIAR_OPERACIONAL'],
      },
      { rotulo: 'Tags', para: '/configuracoes/tags', permissoes: ['CATALOGO_GERENCIAR_OPERACIONAL'] },
      { rotulo: 'Auditoria', para: '/configuracoes/auditoria', permissoes: ['AUDITORIA_LER'] },
    ],
  },
]
